<template>
	<nav class="top-navigation">
		<!-- first-level -->
		<ul class="first-level">
			<li v-for="(key, index) in params.menu"
				v-if="countMenuElements() > index"
				:key="key.id"
				@mouseenter="mouseEnterFirstLevel"
				@mouseleave="mouseLeaveFirstLevel"
				:class="{open: key.active}"
			>
				<a :href="key.href">
					{{ key.text }}
					<svg v-if="key.submenu" width="12px" height="12px">
						<use xlink:href="#svg-arrow-down"></use>
					</svg>
				</a>
				<!-- second-level -->
				<div class="second-level" :class="{visible: key.active}">
					<ul class="" v-if="key.submenu">
						<li v-for="(element, i) in key.submenu" :key="element.id">
							<a :href="element.href"
								@mouseenter="hoverLevelTwo($event, i, !!element.submenu, key.submenu.length)"
							   :class="{open: element.active}"
							>
								<div v-if="element.image" v-html="element.image" class="icon"></div>
								{{ element.text }}
								<svg v-if="element.submenu" class="sub-menu" width="18px" height="18px">
									<use xlink:href="#arrow-right"></use>
								</svg>
							</a>
						</li>
					</ul>
					<div class="hidden-block">
						<!-- third-level -->
						<div v-for="element in key.submenu" class="third-level"
							:class="{visible: element.active}"
						>
							<ul v-for="(el, i) in splitFunction(element, element)">
								<li v-for="x in el">
									<a :href="x.href">
										<span class="icon" v-html="x.image"></span>
										{{ x.text }}
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			<li  class="extra-menu">
				<svg :class='toogleExtraMenu ? "animSVG" : ""' @click="toogleExtraMenu = !toogleExtraMenu"
					 width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
					<line x1="3" y1="12" x2="21" y2="12"></line>
					<line x1="3" y1="6" x2="21" y2="6"></line>
					<line x1="3" y1="18" x2="21" y2="18"></line>
				</svg>
				<div class="hidden-block" :class='toogleExtraMenu ? "active" : ""'>
					<a v-for="(key, index) in params.menu"
						v-if="countMenuElements() <= index"
						:href="key.href">
						{{ key.text }}
					</a>
				</div>
			</li>
		</ul>
	</nav>
</template>

<script>
	export default {
		props: ['dataParams', 'screenWidth'],
		data() {
			return {
				params: this.dataParams,
				toogleExtraMenu: false
			}
		},
		watch: {
			toogleExtraMenu(val) {
				if(val) {
					document.addEventListener('click', this.anotherClick, {capture: true});
				} else {
					document.removeEventListener('click', this.anotherClick, {capture: true});
				}
			}
		},
		methods: {
			countMenuElements() {
				if(this.screenWidth > 1919) {
					return 7;
				} else if (this.screenWidth > 1179 ) {
					return 7;
				} else if (this.screenWidth > 1020 ) {
					return 7;
				} else if (this.screenWidth > 700) {
					return 5;
				}    else if (this.screenWidth > 640) {
					return 5;
				}  else if (this.screenWidth < 640) {
					return 50000;
				}
				else {
					return 4;
				}
			},
			anotherClick(e){
				if($(e.target).closest('.extra-menu').length > 0) return;
				this.toogleExtraMenu = false;
			},
			mouseEnterFirstLevel(e) {
				let menuLevelTwo = e.target.querySelector('.second-level');
				if(menuLevelTwo) {
					menuLevelTwo.classList.add('visible');
					e.target.classList.add('open');
				}

			},
			mouseLeaveFirstLevel(e) {
				let menuLevelTwo = e.target.querySelector('.second-level');
				if(menuLevelTwo) {
					menuLevelTwo.classList.remove('visible');
					e.target.classList.remove('open');
				}
			},
			hoverLevelTwo(event, index, prevent, nextBlock) {
				//if(!prevent) return;
				//event.preventDefault();

				// third-level
				let allHiddenBlocks = $(event.target).closest('.second-level').find('.hidden-block').children();

				if(!$(allHiddenBlocks[index]).hasClass('visible')) {
					$(event.target).closest('ul').find('> li > .open').removeClass('open');
					$(event.target).addClass('open');

					$(allHiddenBlocks).removeClass('visible');
					$(allHiddenBlocks[index]).addClass('visible');
					return;
				};
				//$(event.target).closest('ul').find('> li > .open').removeClass('open');
				//$(allHiddenBlocks).removeClass('visible');
			},
			splitFunction(oldArray, parent) {
				var oldArray = oldArray.submenu;
				if(!oldArray) return undefined;
				let arr = [];

				if(oldArray.length < 10){
					arr.push(oldArray);
				} else if(oldArray.length >= 10) {
					arr.push(oldArray.slice(0, 10));
				}

				if(oldArray.length >= 20) {
					arr.push(oldArray.slice(10, 19).concat([{
						href: parent.showMore.href,
						text: parent.showMore.text,
						showMore: true
					}]));
				}else if(oldArray.length >= 11 && oldArray.length <= 19) {
					arr.push(oldArray.slice(10, oldArray.length));
				}
				return arr;
			}
		},
		mounted() {
			$('.second-level > ul').perfectScrollbar();
		}
	}
</script>
<style lang="scss">
	.top-navigation{
		height: 55px;
		padding: .125rem 0 7px;
		display: flex;
		align-items: center;
		width: 100%;
		.first-level{
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;
			height: 100%;
			> li {
				display: flex;
				align-items: center;
				position: relative;
				height: 100%;
				> a {
					display: flex;
					height: 100%;
					align-items: center;
					svg {
						margin-left: 4px;
						transition: 0.2s transform linear;
					}
				}
				&.open{
					> a {
						svg {
							transform: rotate(180deg);
						}
					}
				}
			}
		}
		.second-level{
			position: absolute;
			z-index: 30;
			background-color: #fff;
			top: 100%;
			pointer-events: none;
			opacity: 0;
			transition: all .2s ease 0ms;
			transform: translateY(-10px);
			border-top: 4px solid var(--bg-color);
			display: flex;
			&.visible {
				pointer-events: auto;
				opacity: 1;
				transform: translateY(-2px);
			}
			& > ul {
				max-height: 454px;
				min-height: 360px;
				overflow-y: auto;
				width: 262px;
				position: relative;
				& > li {
					display: flex;
					align-items: center;
					border-bottom: 1px solid #ebebec;
					height: 45px;
					& > a {
						display: flex;
						align-items: center;
						height: 100%;
						width: 100%;
						font-size: 0.9375rem;
						padding: 0 15px;
						transition: 0.2s all linear;
						& .icon {
							margin-right: 10px;
							flex-shrink: 0;
							display: flex;
							align-items: center;
							svg{
								width: 15px;
								height: 15px;
								fill: var(--bg-color);
							}
						}
						> svg {
							margin-left: auto;
							transition: 0.2s transform linear;
							flex-shrink: 0;
						}
						&.open {
							background-color: var(--bg-color);
							color: var(--ct-color);
							> svg, .icon svg{
								fill: var(--ct-color);
							}
						}
					}
				}
			}
		}
		.third-level {
			display: none;
			background-color: #f9f9f9;
			height: 100%;
			&.visible {
				display: flex;
					ul {
						width: 280px;
						li {
							border-bottom: unset;
							padding-left: 15px;
							padding-right: 15px;
							transition: 0.2s background-color linear;
							& > a {
								display: flex;
								align-items: center;
								width: 100%;
								min-height: 43px;
								transition: 0.2s all linear;
								.icon {
									margin-right: 5px;
									flex-shrink: 0;
									svg{
										width: 15px;
										height: 15px;
										fill: var(--bg-color);
										transition: 0.2s fill linear;
									}
								}
								&.show-more{
									color: var(--bg-color);
								}
							}
							&:not(:last-child) > a{
								border-bottom: 1px solid #ebebec;
							}
							&:hover {
								background-color: var(--bg-color);
								a {
									color: var(--ct-color);
									border-bottom-color: var(--bg-color);
									&.show-more {
										color: var(--ct-color);
									}
								}
								.icon svg {
									fill: var(--ct-color);
								}
							}
						}
					}
			}
		}
		.extra-menu{
			position: relative;
			svg{
				display: inline-block;
				margin-bottom: 3px;
				margin-top: -1px;
				stroke: #333333;
				cursor: pointer;
				transform: rotate(0deg);
				line{
					-webkit-transition: all 200ms;
					-moz-transition: all 200ms;
					-o-transition: all 200ms;
					transition: all 200ms;
				}
				line:nth-child(2){
					-webkit-transition: all 0ms;
					-moz-transition: all 0ms;
					-o-transition: all 0ms;
					transition: all 0ms;
				}
				&.animSVG {
					line:nth-child(1){
						-webkit-transform: translateX(11px) translateY(-6px) rotate(45deg);
						-moz-transform: translateX(11px) translateY(-6px) rotate(45deg);
						-o-transform: translateX(11px) translateY(-6px) rotate(45deg);
						transform: translateX(11px) translateY(-6px) rotate(45deg);
					}
					line:nth-child(2){
						visibility: hidden;
					}
					line:nth-child(3){
						-webkit-transform: translateX(-10px) translateY(7px) rotate(-47deg);
						-moz-transform: translateX(-10px) translateY(7px) rotate(-47deg);
						-o-transform: translateX(-10px) translateY(7px) rotate(-47deg);
						transform: translateX(-10px) translateY(7px) rotate(-47deg);
					}
				}
			}
			.hidden-block{
				position: absolute;
				opacity: 0;
				pointer-events: none;
				background-color: #fff;
				top: 147%;
				padding: 30px;
				right: 0px;
				width: 210px;
				border-radius: 5px;
				box-shadow: 0 0 10px 2px rgba(52,78,96,.17);
				background-color: var(--bg-color);
				transition: all .3s ease 0ms;
				transform: scale(.1) translateY(-300px);
				display: flex;
				flex-direction: column;
				&:before {
					content: "";
					position: absolute;
					right: 0;
					top: -16px;
					width: 0;
					height: 0;
					border-style: solid;
					border-width: 0 0 20px 18px;
					border-color: transparent transparent var(--bg-color);
				}
				&.active{
					opacity: 1;
					pointer-events: auto;
					top: 200%;
					transform: scale(1) translateY(0);
					z-index: 31;
				}
				a{
					/*padding-top: 15px;*/
					font-size: 14px;
					color: var(--ct-color);
					&:not(:last-child) {
						padding-bottom: 15px;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// navigation-desctop.vue?dd8e024e